module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chats"
  }, [_c('header-bar'), _vm._v(" "), _c('section', {
    staticClass: "chat"
  }, [_c('div', {
    staticClass: "grid-container"
  }, [_c('list', {
    attrs: {
      "chats": _vm.chats
    }
  }), _vm._v(" "), (_vm.current && _vm.current !== 'new') ? _c('conversation', {
    attrs: {
      "id": _vm.current,
      "after": _vm.chat.showAfter
    }
  }) : _vm._e(), _vm._v(" "), (this.$route.params.id === 'new') ? _c('new') : _vm._e()], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5803653a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Chats.vue
// module id = 712
// module chunks = 1